import get from 'lodash/get';
import { Modal, useModal } from 'UI/components/Modal';
import { ContactForm } from 'UI/components/ContactForm';
import { getDocumentFields, getFileUrl } from 'utils/helper';
import styles from './styles.module.scss';

const Cta = ({ section }) => {
  const { open, onOpen, onClose } = useModal();
  const { contentModules } = getDocumentFields(section, ['contentModules']);
  const {
    title,
    description,
    imagesBundle,
    buttonTitle,
  } = getDocumentFields(get(contentModules, '[0]', {}), [
    'title',
    'description',
    'imagesBundle',
    'buttonTitle',
  ]);

  const file = get(imagesBundle, '[0]', {});
  const background = getFileUrl(file);

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div
          className={styles.cta}
          style={{ backgroundImage: `url(${background})` }}
        >
          {title && (
            <h4 className={styles['cta-title']}>{title}</h4>
          )}
          {buttonTitle && (
            <button
              type="button"
              onClick={onOpen}
              className={styles['cta-button']}
            >
              {buttonTitle}
            </button>
          )}
        </div>
      </div>
      <Modal
        open={open}
        onClose={onClose}
        className={styles['contact-form-modal']}
      >
        <ContactForm
          title={title}
          description={description}
          open={open}
          onClose={onClose}
        />
      </Modal>
    </section>
  );
};

export default Cta;
